import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="404 - Page Not Found | Shikwaru Adventures"
        description="The page you're looking for doesn't exist. Return to Shikwaru Adventures homepage to explore our African safari tours."
        canonical={location.pathname}
      />
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-secondary/30 to-background">
        <div className="text-center px-4 max-w-2xl">
          <h1 className="mb-4 text-8xl font-bold text-primary">404</h1>
          <h2 className="mb-4 text-3xl font-semibold">Page Not Found</h2>
          <p className="mb-8 text-xl text-muted-foreground">
            Oops! The page you're looking for seems to have wandered off into the African wilderness.
          </p>
          <a href="/">
            <Button size="lg" className="gap-2">
              <Home size={20} />
              Return to Homepage
            </Button>
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
